import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../common/api/queryKeys/queries';

export const useManagementUser = (userId: string) => {
    return useQuery(queries.members.detail(userId));
};
